/**
 * Scheduler Contractor - Main Entry Point
 *
 * Scoped task queue for contractors:
 * - View assigned tasks only (no customer names visible)
 * - Start/stop assigned tasks
 * - Time tracking
 *
 * See DESIGN-SYSTEM.md for UI standards.
 * See CLAUDE.md § Contractor Visibility Enforcement.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
